if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartPage = document.querySelector('cart-items');

      // get the product info component
      this.productInfo = this.closest('product-info');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // handle fake variant errors and return if there is an error
      if (this.productInfo && !this.productInfo.handleFakeVariantError()) {
        return;
      }

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('button--loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let sectionsToFetch = [];

      if (this.cartDrawer)
        this.cartDrawer.getSectionsToRender().map((section) => sectionsToFetch.push(section.id));

      if (this.cartNotification)
        this.cartNotification
          .getSectionsToRender()
          .map((section) => sectionsToFetch.push(section.id));

      if (this.cartPage)
        this.cartPage.getSectionsToRender().map((section) => sectionsToFetch.push(section.section));

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          if (this.cartDrawer != null) {
            this.cartDrawer.renderContents(parsedState);
          }

          switch (submitButton.dataset.addToCartBehavior) {
            case 'open_cart_drawer':
              // Set timeout to force animation. Because content is just updated with renderContents
              setTimeout(() => {
                this.cartDrawer.open();
              });
              break;
            case 'show_cart_notification':
              this.cartNotification.setActiveElement(document.activeElement);
              this.cartNotification.renderContents(parsedState);
              break;
            default:
              this.cartPage.updateSections(parsedState);
              break;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('button--loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
